const year = new Date().getFullYear()
const en = {
  header: {
    about: 'About',
    contact: 'Contact',
    pricing: 'Pricing',
    ReportAbuse: 'Report Abuse',
    InvitationSystem: 'Invitation System',
    verify_email: 'verify email',
    sign_in: 'Sign in',
    dashboard: 'Dashboard',
    biolink_page: 'Biolink Page',
    admin: 'Admin',
    logout: 'Logout',
    sign_up: 'Sign up',
    about_us: 'About Us',
    name:'Daniel Jones',
    post:'CEO & Founder',
    contact_us: 'Contact Us',
    payments_list: 'Payments list',
  },
  footer: {
    terms_conditions: 'Terms & Conditions',
    privacy_policy: 'Privacy Policy',
    copyright: 'Copyright © ' + year + ' bil.bio',
    Update_cookies_preferences: 'Manage Cookies',
  },
  biolink_title: {
    edit: 'Edit',
    delete: 'Delete',
    delete_cap: 'DELETE',
    save_cap: 'SAVE',
    view: 'View',
    settings: 'Settings',
    duplicate: 'Duplicate',
    your_link_is: 'Your link is',
    copy_to_clipboard: 'Copy To Clipboard',
    copied: 'Copied',
    change_status: 'Change Status',
    edit_user: 'Edit user',
    block: 'Block',
    november: 'November',
    maximum: 'Maximum',
    add_cap_modal: 'ADD',
  },

  auth: {
    create_your_account: 'Create Your Account',
    signup_to_bilbio_and_create_your_biolink_now:
      'Signup to bilbio and create your Biolink NOW!',
    pagename: 'Pagename',
    enter_page_name: 'Enter Page Name',
    enter_page_email: 'Enter Email Address',
    by_creating_an_account_you_agreeing_to_our:
      'By creating an account, you agreeing to our',
    log_in: 'LOG IN',
    create_account: 'CREATE ACCOUNT',
    hi_welcome_back: 'Hi, Welcome Back!',
    enter_you_details_to_login_into_your_bilbio_account:
      'Enter you details to login into your bilbio account',
    enter_password: 'Enter Password',
    login: 'LOGIN',
    sign_up: 'SIGN UP',
    do_not_have_an_account: 'Do not have an account?',
    page_name_required: 'Page Name required',
    pass_required: 'Password Required',
    this_username_is_already_taken: 'This username is already taken',
    page_name_cannot_contain_symbols: 'Page Name cannot contain symbols',
    forgot_your_password: 'Forgot Your Password',
  },
  Invitation_System: {
    More_than_a_todo_app: 'More than a todo app',
    paragraph:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit quam eum facere explicabo, dolorum sed consequuntur incidunt, culpa cum voluptatem, eaque consectetur saepe rerum dolor? Cum eius labore debitis minus.',
    thanks_for_siging: 'Thank you for Signing In',
    verify_your_email: 'Verify your email',
    confirm_email:
      'Please confirm that you want to use this as your email address',
    verify_email: 'VERIFY EMAIL',
    bilbio_Account_activated: 'Bill Bio Account Activated',
    hello: 'Hello John',
    email_verified:
      'Thank you , Your email has been verified. Your Account is active now.',
    link_login_account: 'Please use this link below to login to your account',
    login_account: 'LOGIN ACCOUNT',
    invite_friend: 'Invite Friend',
    invite_friend_cap: 'INVITE FRIEND',
    you_have: 'You have',
    credits: 'credits',
    friend: 'Friend',
    sent: 'sent',
    invite_success: 'Invites Sent Successfully.',
    invite_failed: 'Error While Sending Invite.',
    invite_resend: 'RESEND INVITE',
  },

  front_end_pages: {
    home_page: {
      hero_section: {
        main_title_part_one: 'Build one single link',
        main_title_part_two: 'for all your links',
        sub_title:
          'Utilize various online platforms to engage with like-minded individuals, gain exposure, and establish a digital presence for your creative endeavors, all of it from your one biolink. ',
      },
      features_section: {
        biolink: 'Biolink',
        create: 'CREATE',
        create_your: 'Create your',
        unique: 'unique',
        sec_one_first_line:
          'Generate your personalized link page effortlessly within seconds.',
        sec_one_sec_line:
          'Unify your entire online presence into one single link.',
        sec_one_thired_line:
          'One link to share everything with your followers.',
        sec_one_four_line:
          'Personalize your biolinks, keep them short & crisp, and easier to share.',
        customize: 'CUSTOMIZE',
        design: 'Design',
        exceptional: 'exceptional',
        sec_two_first_line:
          'Create your own unique & highly customizable bio link page with ease.',
        sec_two_sec_line:
          'Personalize your biolink with custom colors & branding.',
        sec_two_thired_line:
          'Experience made easier with multiple ready-to-use components.',
        sec_two_four_line:
          'Add your Instagram, Twitter, Snapchat, TikTok, Youtube, social media handles, images and more.',
        share: 'SHARE',
        add_your_biolink_to_your: 'Add your Biolink to your',
        social_media: 'social media',
        handles: 'handles',
        sec_thered_first_line:
          'Add your customized biobil URL to all the platforms to reach your audience.',
        sec_thered_sec_line:
          'Personalize your biolink with custom colors & branding.',
        sec_thered_thired_line:
          'Experience made easier with multiple ready-to-use components.',
        sec_thered_four_line: 'Add Branding and SEO Optimization.',
      },
      pricing_section: {
        subscription: 'SUBSCRIPTION',
        choose_a: 'Choose a',
        plan: 'plan',
        that_works_for_you: 'that works for you',
        monthly: 'Monthly',
        annual: 'Annual',
        what_included: 'What’s included',
        unlimited_biolink_pages: 'Unlimited Biolink Pages',
        unlimited_biolink_blocks: 'Unlimited Biolink Blocks',
        bio_pages: '25 Biolink Pages',
        seo_feature: 'SEO Features',
        brandings: 'Brandings',
        customer_support: '24*7 Customer Support',
      },
      create_page_section: {
        bilbio: 'bilbio',
        start_creating_your_exclusive: 'Start creating your exclusive',
        start_creating_your_exclusive_bilbio:
          'Start creating your exclusive bilbio',
        biolink_url: 'biolink URL',
        now: 'NOW',
      },
    },
    about: {
      description_text:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500 s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.It was popularised in the 1960 s with the release of Letraset sheets containing Lorem Ipsum.",
      description_text_mobile:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500 s, when an unknown printer took a galley.",
      team: 'Team',
      meet_our_amazing: 'Meet Our Amazing',
      view_all: 'View All',
      get_in_touch: 'GET IN TOUCH',
    },
    contact: {
      fill_up_your_contact: 'Fill up your contact',
      information_and_our_team: 'information and our team',
      will_get_back_to_you: 'will get back to you.',
      enter_first_name: 'Enter First Name',
      enter_last_name: 'Enter Last Name',
      enter_phone_number: 'Enter Phone Number',
      enter_email: 'Enter Email Address',
      enter_message_here: 'Enter Message here',
      last_name: 'Last name',
      phone_number: 'Phone Number',
      enter_valid_number: 'Enter valid number',
      message: 'Message',
      last_name_required: 'Last Name Required',
      phone_number_required: 'Phone Number Required',
      the_email_should_have_less_then_characters:
        'The email should have less then 50 characters',
      message_required: 'Message field required',
    },
    pricing: {
      simple_plans_for: 'Simple plans for',
      everyone: 'everyone',
      have_a_coupon: 'Have a coupon?',
      choose_your_plan_get_amazing_discounts_cancel_anytime:
        'Choose your plan. Get amazing discounts. Cancel anytime.',
      free_plan: 'Free plan',
      premium_plan_paid: 'Premium Plan (Paid)',
    },
    privacy_policy: {
      lorem_ipsum_is_simply_dummy_text_of_the_printing:
        'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      lorem_ipsum_has_been_the_industry_standard_dummy_text:
        "Lorem Ipsum has been the industry's standard dummy text.",
      what_is_lorem_ipsum: 'What is Lorem Ipsum?',
      first_para:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      second_para:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum",
      li_one:
        'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.',
      li_two:
        'Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.',
      li_three:
        'Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC.',
      li_four:
        'This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.',
      why_do_we_use_it: 'Why do we use it?',
      last_para:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
    },
  },
  cms: {
    appearance: 'Appearance',
    location: 'Location',
    profile: 'Profile',
    seo: 'Seo',
    page: 'Page',
    account: 'Account',
    security: 'Security',
    billings: 'Billings',
    custom_image: 'Custom Image',
    maximum: 'maximum',
    choose_another: 'CHOOSE ANOTHER',
    select_font: 'Select Font',
    rounded_corners: 'Rounded corners',
    circle: 'Circle',
    full_rounded_corners: 'Full Rounded corners',
    straight_corners: 'Straight corners',
    outline: 'Outline',
    button_background_color: 'Button Background color',
    timer_digit_color: 'Timer Digit color',
    timer_background_color: 'Timer Background Color',
    button_font_color: 'Button Font color',
    outline_style: 'Outline Style',
    outline_width: 'Outline Width',
    corners: 'corners',
    insert_graph_image: 'INSERT GRAPH IMAGE',
    enble_block_search_engine_indexing: 'Enble Block Search Engine Indexing',
    page_title_required: 'Page Title required',
    meta_description_required: 'Meta Description required',
    branding_url_required: 'Branding URL required',
    enter_title: 'Enter Title',
    enter_url: 'Enter URL',
    enter_meta_description: 'Enter Meta Description',
    enter_page_title: 'Enter Page Title',
    enter_alt_text: 'Enter ALT Text',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    scan_qr_code: 'Scan QR Code',
    cancel: 'Cancel',
    you_sure_want_to_logout: 'Are you sure you want to Logout?',
    previous: 'Previous',
    next: 'Next',
  },
  appearance: {
    background_cap: 'BACKGROUND',
    background: 'Background',
    favicon_cap: 'FAVICON',
    favicon: 'Favicon',
    fonts_cap: 'FONTS',
    fonts: 'Fonts',
    seo_cap: 'SEO',
    seo: 'Seo',
    avatar_cap: 'AVATAR',
    avatar: 'Avatar',
    link_cap: 'LINK',
    link: 'Link',
    branding_cap: 'BRANDING',
    branding: 'Branding',
  },

  contact: {
    name_required: 'Name is required',
    only_alphabets: 'Only alphabets are allowed for this field ',
    more_characters: 'Name cant more than 20 characters.',
    valid: 'Email must be a valid',
    subject: 'Subject is required',
    subject_max: 'Subject cant more than 30 characters.',
    message: 'Message is required',
    message_min: 'Minimum Message Must be 40 characters long.',
    message_max: 'Message Cant more than 250 characters.',
  },

  descriptions: {
    shorten_urls:
      'Utilize various online platforms to engage with like-minded individuals, gain exposure, and establish a digital presence for your creative endeavors, all of it from your one biolink. ',
    fully_featured:
      'Fully featured QR code generator system with easy to use templates.',
    update_checkout: 'Update & continue to Golden checkout',
    plans_management: 'Plans Management',
    create_plan: 'Create Plan',
    no_account: 'Dont have an account?',
    leave_empty: 'Leave empty for a random generated one.',
    scan_qr:
      'If you want to activate two factor authentication scan the QR Code or enter the secret key in Google Authenticator App and enter OTP',
    skip: 'Or skip',
    copy_Qr: 'Copy the secret key it is confidential',
    scanned: 'Check your email OR  Google Authenticator for code. ',
    do_everything: 'Do everything',
    with_one: 'with one',
    platform: 'platform',
    get_started: 'GET STARTED',
    create_own:
      'Create your own unique & highly customizable bio link page with ease.',
    custom_colors: 'Custom colors & branding',
    ready_to_use: 'Multiple ready-to-use components',
    protection: 'Password protection, sensitive content warning',
    seo_setting: 'SEO Settings',
    shortened_links: 'Shortened Links',
    service: 'Yes! You can use our service as a shortener as well.',
    demographic: 'Country, device & language targeting',
    scheduling: 'Scheduling & expiration limits',
    ab_rotation: 'A/B Rotation',
    password: 'Password protection, sensitive content warning',
    built_in: 'Built-in analytics',
    generate_links:
      'Generate dynamic links to files and benefit from tracking, protection, pixels & expiration features.',
    generate_vcard:
      'Generate dynamic vcard links to your contact downloadable card and benefit from tracking, protection, pixels & expiration features.',
    day_by:
      'For daily analytics, referrals, countries, operating systems, languages ​​and many more.',
    connect: 'Connect your own domain or use our predefined ones.',
    easiest_way: 'Easiest way to categorize your managed resources.',
    offering: 'We also give you a set of 35 useful web tools as a bonus.',
    choose_yourself: 'Choose and get exactly what you need.',
    feel_free: 'Feel free to contact us',
    enter_message: 'Enter your message here.',
    add_multiple_images: 'Add Multiple Images',
    add_link: 'Add a Link Button',
    add_new: 'Add a new block',
    add_heading: 'Add a Heading',
    add_avatar: 'Add a Avatar',
    add_social: 'Add social links',
    choose_custom_plan: 'Start the Golden Plan',
    almost_there: 'You are almost there, no strings attached.',
    trial_start: 'Start my 7 Days Trial',
    skip_trial: 'Skip Trial',
    trial_info:
      'By continuing with your order you confirm that you read, understand & agree to the  of the site.',
    terms: 'Terms and Conditions',
    add_image: 'Add an Image',
    img_description: 'Image description for accessibility & SEO purposes.',
    add_youtube: 'Add a YouTube video',
    paste_video_url:
      'Paste in your YouTube video URL and we will show it as a video on your profile.',
    add_tiktok: 'Add a TikTok video',
    tiktok_url: 'TikTok Video URL',
    valid_email: 'Email must be a valid email address',
    distination_Url: 'distination_url',
    email_required: 'Email is required',
    password_required: 'Password is required',
    name_required: 'Name is required',
    user_name_required: 'User name is required',
    firstName_required: 'First name is required',
    firstName_must_alphabets: 'First name must contain only alphabets.',
    lastName_must_alphabets: 'Last name must contain only alphabets.',
    enter_email:
      'Please enter the email address associated with your account and We will email you a link to reset your password.',
    already_account: 'Already have an account?',
    paste_tiktok: 'Share your TikTok video url',

    drag_drop: 'Drag & Drop to Reorder',
    can_confirm: 'I confirm that I have read and understood the',
    of_site: 'of the site.',
    confirm_password: 'Confirm New Password',
    confirm_new: 'Confirm password is required',
    field_required: 'Field Required',
    add_instagram: 'Add an Instagram Post',
    entered_url: 'Your entered URL is invalid for embedding',
    least_characters: 'Password must be at least 6 characters',
    must_match: 'Passwords must match',
    check_email: 'Please check your email!',
    sent_code:
      'We have emailed a 6-digit confirmation code to acb@domain, please enter the code in below box to verify your email.',
    no_code: 'Dont have a code?',
    code_required: 'Code is required',
    checking_email: 'Checking user Email',
    monthly_payment: 'Monthly payment',
    golden_plan: 'Golden plan',
    plan_detail:
      'You are almost there, complete the following form and checkout.',
    payment_frequency: 'Payment frequency',
    annual_payments: 'Annual Payments',
    lifetime_deal: 'Lifetime deal',
    payment_method: 'Payment method',
    payment_method_stripe: 'Payment by Stripe',
    type_payment: 'Type of payment',
    stripe: 'Stripe',
    one_payment: 'One Time Payment',
    recurring_payment: 'Recurring Payment',
    order_summary: 'Order summary',
    plan: 'Plan',
    golden: 'Golden',
    frequency: 'Frequency',
    monthly: 'Monthly',
    type: 'Type',
    one_time: 'One time',
    paid_with: 'Paid with',
    pay_pal: 'PayPal',
    price: 'Price',
    code_redeemable: 'I have a discount/redeemable code',
    code: 'Code',
    total: 'Total',
    checkout: 'Checkout',
    day: 'Every 30 days',
    billing: 'Billing',
    choosen_plan: 'Choosen Plan',
    home: 'Home',
    what_get: "What you'll get",
    one_product: 'One end products',
    month_update: '12 months updates',
    month_support: '6 months of support',
    bio_pages: '25 Biolink Pages',
    bio_block: '10 Biolink Blocks',
    all_block: 'All Biolink Blocks',
    short_link: '250 Shortened Links',
    file_link: '2 File Links',
    vcard_link: '2 Vcard Links',
    qr_code: '5 QR Codes',
    proj: '50 Projects',
    pixel: '5 Pixels',
    custom_domain: 'Custom Domains',
    day_stat: '365 days statistics retention',
    global_domain: 'Additional Global Domains ',
    back_half: 'Custom Back-half',
    deep_lnk: 'Deep linking',
    removable_brand: 'Removable branding',
    custom_back: 'Custom Backgrounds',
    custom_col: 'Custom colors',
    defollow: 'Dofollow links',
    leap_link: 'Leap link',
    seo_feature: 'SEO Features',
    extra_font: 'Extra fonts',
    add_tweet: 'Add a Tweet',
    custome_css: 'Custom CSS',
    custom_js: 'Custom JS',
    no_ad: 'No ads',
    api_access: 'Api access',
    fill: 'Fill in your billing details',
    handling:
      'We require your billing details for generating proper invoices & for tax handling, provide valid billing details only.',
    user_manag: 'User Management',
    user_logs: ' Users logs',
    user_creat: 'Create User',
    set_2fa: 'Setup 2-Factor Authentication',
    user: 'User',
    showout_result: 'Showing Results',
    status: 'Status',
    applied_codes: 'Applied Codes',
    applied_taxes: 'Applied Taxes',
    detail: 'Details',
    bulk_actions: 'Bulk Actions',
    hidden_demo: 'hidden on demo',
    cant_undone: ' cannot be undone.',
    login_thisuser: 'Login as this user',
    loginmodal_detail1:
      'By logging in as another user, you will be logged out of the',
    loginmodal_detail2: 'current account and fully logged in to this user.',
    show_result: 'Showing 1-12 out of 12 results.',
    total_sales: 'Total Sales',
    visitors: 'Visitors',
    page_views: 'PageViews',
    paste_instagram_url: 'Paste URL of an Instagram post',
    delete_block_des:
      'All data related to the biolink block will be completely deleted. This action cannot be undone.',
    duplicate_block_des:
      'Easily duplicate this resource with a click of a button.',
    delete_block: 'Delete block',
    duplicate_block: 'Duplicate block',
    total_amount: 'Total Amount',
    admin_privileges:
      'Admin users will have the same privileges as you, be careful!',
    change_passDetail:
      "Leave it empty if you don't want to change the user's password!",
    new_pass: 'New password',
    repeat_pass: 'Repeat Password',
    block_search: 'Block Search Engine Indexing',
    block_biolink:
      'Block your biolink page from being indexed by search engines.',
    change_page:
      'Completely change the page title to a custom one that you are setting here.',
    custom_meta:
      'Set a custom meta description for your biolink page to rank better in search engines.',
  },

  admin: {
    welcome: 'Welcome Back',
    biolink_pages: 'Biolink Pages',
    pageviews_tracked: 'Pageviews tracked',
  },

  label: {
    view_user: 'View User',
    privileges: 'Privileges',
    timezone: 'Timezone',
    Factor_authentication: 'Two Factor authentication',
    Factor_authentication_2: '2 Factor authentication',
    Anti_code: 'Anti pishing code',
    active: 'Active',
    english: 'English',
    no: 'No',
    api_key: 'API Key',
    total_logins: 'Total logins',
    last_useragent: 'Last user agent',
    last_active: 'Last Active',
    country: 'Country',
    direct_signup: 'Direct sign up',
    source: 'Source',
    trial_done: 'Trial is done',
    last_subid: 'Last subcription id',
    last_payamount: 'Last payment amount',
    last_payprocessor: 'Last payment processor',
    plan_expdate: 'Plan expiration date',
    free: 'Free',
    disabled: 'Disabled',
    hidden: 'Hidden',
    arabic: 'Arabic',
    main_language: ' Main language',
    add_tweet: 'Add a Tweet',
    update: 'Update',
    change_password: 'Change Password',
    enable_stripepay: 'Enable Stripe payments',
    publishable_key: 'Publishable Key',
    secret_key: 'Secret Key',
    webhook_secret: 'Webhook Secret',
    webhook: 'Webhook',
    more_detail: ' to get more details on certain available configurations.',
    read_the: 'Read the',
    documentation: 'Documentation',
  },

  addBlock: {
    choose_avatar: 'CHOOSE AVATAR',
    essentials: 'ESSENTIALS',
    text: 'TEXT',
    media: 'MEDIA',
    miscellaneous: 'MISCELLANEOUS',
    addBlocks: 'Add Blocks',
    viewBlock: 'View Block',
    paymentDetails: 'Payment Details',
    renewal: 'Renewal',
    inclusive_tax: 'Inclusive Tax',
    apply: 'APPLY',
    plan: 'Plan',
    enter_coupon_code: 'Enter Coupon Code',
    set_up_your: 'SET UP YOUR',
    credit_debit_card: 'CREDIT/DEBIT CARD',
    card_number: 'Card Number',
    card_number_is_required: 'Card Number is required',
    please_enter_valid_card_number: 'Please Enter valid card number',
    please_enter_valid_cvv_number: 'Please Enter valid CVV',
    expiry_date_is_required: 'Expiry Date is required',
    expiry_date: 'Expiry Date',
    enter_valid_month: 'Enter Valid Month',
    enter_valid_year: 'Enter Valid Year',
    expiry_date_valid_month_year: 'Enter Valid Expiry Date',
    cvv_is_required: 'CVV is required',
    invalid_characters_in_name: 'Invalid characters in name',
    change: 'CHANGE',
    renew_plan_automatically:
      'Renew plan automatically at the end of every month Cancel anytime.',
    make_payment: 'MAKE PAYMENT',
    subscribe_start_customizing: 'Subscribe and start customizing',
    your_biolink_now: 'your Biolink NOW!',
    year: 'Year',
    month: 'Month',
    annual: 'Annual',
    off: 'Off',
    auto: 'Auto',
    payment_successful: 'Payment Successful',
    enjoy: 'ENJOY',
    using_premium_and_continue: 'using Premium and continue creating',
    exclusive_biolinks: 'exclusive Biolinks',
    page: 'Page',
    account: 'Account',
    account_: 'ACCOUNT',
    security: 'Security',
    billings: 'Billings',
    setting: 'Setting',
    page_name: 'PAGE NAME',
    update_your_page_name:
      'Update your page name to create your unique identity.',
    save_changes: 'SAVE CHANGES',
    page_name_cannot: 'Page Name cannot contain symbols',
    remove: 'REMOVE',
    personal_details: 'Personal Details',
    first_name_must_be_valid: 'First Name must be a valid name',
    first_name_must_be_20_characters:
      'First Name should have at most 20 characters',
    email_should_be_50_characters:
      'The email should have at most 50 characters',
    email_address_must_be_valid: 'Email address must be a valid address',
    upload: 'UPLOAD',
    choose_account_type: 'Choose Account Type',
    enter_country: 'Enter Country',
    state_region: 'State/Region',
    enter_state_region: 'Enter State/Region',
    enter_city: 'Enter City',
    zip_code: 'Zip Code',
    enter_zip_code: 'Enter Zip Code',
    account_type_required: 'Account type required',
    country_required: 'Country required',
    State_region_required: 'State/Region required',
    city_required: 'City required',
    zip_required: 'Zip required',
    image_smaller_than_3MB: 'Image must be smaller than 3MB',
    please_select_picture: 'Please select a picture',
    image_size_should_be_3mb:
      'Image size should not exceed 3MB. Allowed files .jpeg and .png.',
    security_: 'SECURITY',
    enter_password_twice: 'Enter new password twice to change your password',
    new_password: 'New Password',
    password_must_8_characters: 'Password must contain at least 8 characters',
    including_uppercase_letter:
      'including 1 uppercase letter, 1 lowercase letter, 1 special character, and 1 numeric value',
    enter_new_password: 'Enter New Password',
    confirm_password: 'Confirm Password',
    password_confirmation_required: 'Password Confirmation required',
    passwords_not_match: 'Passwords do not match',
    enter_confirm_password: 'Enter Confirm Password',
    factor_authentication_description:
      'If you want to activate two factor authentication scan the QR Code or enter the secret key in Google Authenticator App and enter OTP',
    choose_plan_description: 'Choose a plan that suits your requirements',
    billing_history: 'BILLING HISTORY',
    date_joined: 'Date joined',
    last_activity: 'Last activity',
    annually: 'Annually',
    header: 'Header',
    add_header: 'ADD HEADER',
    enter_page_name: 'Enter Page Name',
    enter_page_title: 'Enter Page Title',
    pagename_required: 'PageName is Required',
    pagetitle_required: 'PageTitle is Required',
    contact_required: 'Contact is Required',
    edit_header: 'EDIT HEADER',
    whatapp_required: "Whatsapp is Required",
    whatapp: "Whatsapp",
    profile_alignment: "PROFILE ALIGNMENT",
    left: "Left",
    center: "Center",
    right: "Right",
    want_to_set_background_image: "WANT TO SET BACKGROUND IMAGE",
    avatar_size: "AVATAR SIZE",
    avatar_shape: "AVATAR SHAPE",
    avatar_outline: "AVATAR OUTLINE",
  },

  enter: 'Enter',
  media: 'Media',
  link_URL_must_start: 'Link URL must start with http:// or https://',
  link_icon_required: 'Link Icon required',
  link_url_required: ' Link URL required',
  link_is_required: 'Link Title is required',
  add_icon: 'ADD ICON',
  enter_link: 'Enter link',
  enter_link_title: 'Enter link title',
  custom_link: 'CUSTOM LINK',
  add_image_grid: 'Add Image Grid',
  header_required: 'Header Required',
  enter_header: 'Enter Header',
  header_size: 'Header Size',
  header_: 'Header',
  question_required: 'Question required',
  answer_required: 'Answer required',
  enter_question: 'Enter Question',
  enter_answer: 'Enter Answer',
  choose_time: 'Choose Time',
  choose_date: 'Choose Date',
  drop_your_img: 'Drop your image here or',
  browse_image: 'BROWSE IMAGE',
  save: 'Save',
  components: 'Components',
  payments: 'Payments',
  terms_here: 'Your terms of service go here',
  bold: 'Bold',
  user_id: 'User ID',
  italic: 'Italic',
  underline: 'Underline',
  changelog_config:
    '  Make sure to re-configure your plans settings for the new additional domains configuration',
  initial_release: 'Initial release',
  changelog_detail:
    'All of the updates for Bil Bio will be listed here. Bil Bio versioning is based on the MAJOR.MINOR.PATCH system',
  get_support: 'Get Support',
  support_is: 'Support is ',
  only: 'only',
  done_codecanyon: "done through Codecanyon's",
  email_form: 'email form',
  comments: 'comments',
  section: 'section',
  changelog: 'Changelog',
  edit_home: 'Edit Home',
  home_settings: 'Home Settings',
  docs: 'Docs',
  read_documentation: 'Read Documentation',
  read_changelog: 'Read Changelog',
  latest_users: 'Latest Users',
  page_views: 'Page Views',
  biolinks_pages: 'Biolinks Pages',
  authenticate: 'Authenticate',
  auth_type: 'Auth Type ',
  time_based: 'Time Based ',
  secret_key: 'Secret Key',
  availabe_plan: 'How many days will the plan be available for',
  code_usage: 'How many time the code can be used',
  percent_disc: 'Percentage discount',
  fix_discount: 'Fixed amount discount',
  discount_amount: 'Discount Amount',
  percent_amount: 'Percentage amount',
  duration: 'Duration',
  once: 'once',
  forever: 'forever',
  repeating: 'repeating',
  number_ofmonths: 'Number of months',
  months: 'months',
  currency: 'Currency',
  redeemable: 'Redeemable',
  install_product: 'How to install the product?',
  update_product: 'How to update the product? ',
  customize_product: 'How to customize the product?',
  meta_description: 'Meta Description',
  title: 'Title',
  statistics: 'Statistics',
  opengraph_image: 'OpenGraph Image',
  page_title: 'Page Title',
  countdown: 'Countdown',
  personal: 'Personal',
  business: 'Business',
  city: 'City',
  country: 'Country',
  province: 'Province',
  zip: 'Zip',
  resend_code: 'Resend Code',
  yes: 'Yes',
  choose_plan: 'Choose Plan',
  choose_plan_cap: 'CHOOSE PLAN',
  home: 'Home',
  social: 'Social',
  whatYouWillGet: "What you'll get",
  and: 'and',
  links_statistics: 'Links Statistics',
  oftheSite: 'of the site',
  link: 'Link',
  link_cap: 'LINK',
  telephone: 'Telephone',
  register: 'Register',
  facebook: 'Facebook',
  google: 'Google',
  tracking_pixels: 'Tracking Pixels',
  tool: 'Tool',
  block: 'Block',
  instagram: 'Instagram',
  twitter: 'Twitter',
  username: 'Username',
  add: 'Add',
  add_cap: 'ADD',
  short_url: 'Short URL',
  customization: 'Customization',
  channel: 'Channel',
  branding: 'Branding',
  fonts: 'Fonts',
  submit: 'Submit',
  tracked_reviews: 'Tracked pageviews',
  delete: 'Delete',
  duplicate: 'Duplicate',
  monochrome: 'Monochrome',
  gradient: 'Gradient',
  custom: 'Custom',
  themes: 'Themes',
  background: 'Background',
  simple_gradients: 'Simple Gradients',
  abstract_gradients: 'Abstract Gradients',
  custom_color: 'Custom Color',
  faq: 'FAQ',
  color: 'Color',
  colors: 'Colors',
  custom_image_video: 'Custom Image/Video',
  favicon: 'Favicon',
  share: 'Share',
  image_alt: 'Image Alt',
  maximum: '.png, .gif, .ico, allowed. 2 MB maximum.',
  display: 'Display',
  total_earned: 'Total Earned',
  name: 'Name',
  Unique_user_name: 'Unique user name',
  firstName: 'First Name',
  text_color: 'Text Color',
  default_branding: 'Leave empty to have the default site branding.',
  size: 'Size',
  shape: 'Shape',
  instagram_url: 'Instagram Post URL',
  border_radius: 'Border Radius',
  youtube_url: 'YouTube Video URL',
  total: 'Total',
  biolinks: 'Biolinks',
  biolink: 'Biolink',
  files: 'Files',
  file: 'File',
  biolink_blocks: 'Biolink Blocks',
  card: 'Card',
  destination_url: 'Destination URL',
  codes: 'Codes',
  domains: 'Domains',
  create: 'Create Tax',
  links: 'Links',
  copyright: 'Copyright',
  terms_of_service: 'Terms of Service',
  views: 'views',
  privacy_policy: 'Privacy Policy',
  overview: 'Overview',
  needed_docs:
    'In this page you can find the needed documentation for you to fully install and configure the product',
  product_installation:
    ' The product installation procedure is straight forward and does not require any special / out of the ordinary task Minimum knowledge on how to work with a database and managing files on a server is required',
  policy_here: 'Your Privacy Policy go here',
  requirements: 'Requirements',
  meet_req:
    ' Please make sure your server meets the following requirements before attempting to install or purchase the product.',
  created_on: 'Created on ',
  extensions: 'Extensions',
  database: 'Database',
  server: 'Server',
  other_extentions:
    'Keep in mind, other extensions others than those mentioned here might be required, as these requirements assume you run on a decent, up-to-date server that should have the basic required extensions already working.',
  find_me:
    "I build High quality, ready to use & affordable software. Here's where you can find me:",
  december: 'December',
  twitter_bilBio: 'Twitter @BilBio',
  official_website: 'Official website',
  who_are_we: 'Who are we?',
  all_rights_reserved: 'All rights Reserved',
  export_to: 'Export to',
  filter: 'Filter',
  search: 'Search',
  search_by: 'Search by',
  status: 'Status',
  project: 'Project',
  type: 'Type',
  order_type: 'Order Type',
  results_per_page: 'Results per Page',
  your_custom_alias: 'your-custom-alias',
  mode: 'Mode',
  contrast: 'Contrast',
  direction: 'Direction',
  layout: 'Layout',
  presets: 'Presets',
  stretch: 'Stretch',
  fullscreen: 'Fullscreen',
  exit: 'Exit',
  pricing_plans: 'Pricing plans',
  monthly: 'Monthly',
  annual: 'Annual',
  life_time: 'Lifetime',
  address: 'Address',
  phone: 'Phone',
  send_message: 'SEND MESSAGE',
  email: 'Email',
  subject: 'Subject',
  heading: 'Heading',
  text_editor: 'Text Editor',
  avatar: 'Avatar',
  socials: 'Socials',
  linkedin: 'LinkedIn',
  snapchat: 'SnapChat',
  twitch: 'Twitch',
  spotify: 'Spotify',
  image: 'Image',
  pinterest: 'Pinterest',
  youtube: 'YouTube',
  tiktok: 'TikTok',
  about_section: 'About Section Settings',
  contact_settings: 'Contact Settings',
  Biolink_Page: 'Biolink Page',
  Qr_code: 'QR Code',
  analytics: 'Built-in analytics',
  destination: 'Destination',
  purchased_Plan_monthly: 'You have purchased a monthly Plan.',
  purchased_Plan_yearly: 'You have purchased a annually Plan.',
  purchased_Plan_lifetime: 'You have purchased a lifetime Plan',
  enjoy_your_plan: 'Please enjoy your lifetime plan.',
  close: 'Close',
  want_to_update_plan_yearly_lifetime:
    'Do you want to update your plan Annually or LifeTime?',
  want_to_update_plan_lifetime: 'Do you want to update your plan LifeTime?',
  updating_plan: 'Updating Plan',
  powered_by: 'Powered by',
  text: 'Text',
  round: 'Round',
  rounded: 'Rounded',
  straight: 'Straight',
  solid: 'Solid',
  dashed: 'Dashed',
  double: 'Double',
  outset: 'outset',
  inset: 'Inset',
  border_width: 'Border Width',
  border_color: 'Border Color',
  border_style: 'Border Style',
  infinite: 'Infinite',
  bg_color: 'Background Color',
  animation: 'Animation',
  animation_runs: 'Animation Runs',
  bounce: 'Bounce',
  tada: 'Tada',
  wobble: 'Wobble',
  swing: 'Swing',
  rubberband: 'Rubberband',
  pulse: 'Pulse',
  flash: 'Flash',
  bounce_in: 'BounceIn',
  fade_in: 'FadeIn',
  small: 'Small',
  medium: 'Medium',
  large: 'Large',
  img_thumbnail: 'Image Thumbnail',
  email_address: 'Email Address',
  pass: 'Password',
  forgot_password: 'Forgot Password?',
  forgot_desc: 'Don’t worry! It happens.',
  forgot_description:
    'Please enter the email address associated with your account.',
  login: 'Login',
  remember_me: 'Remember me',
  send_request: 'Send Request',
  back: 'Back',
  dashboard: 'Dashboard',
  plans: 'Plans',
  taxes: 'Taxes',
  website_settings: 'Website Settings',
  languages: 'Languages',
  language_code: 'Language code',
  verify: 'Verify',
  tweet_id: 'Tweet ID',
  divider: 'Divider',
  add_divider: 'ADD DIVIDER',
  seo: 'SEO',
  image_grid: 'Image Grid',
  codes_management: ' Codes Management',
  create_tax: 'Create Tax',
  redeemed: 'Redeemed',
  quantity: 'Quantity',
  discount: 'Discount',
  tax: 'Tax',
  billing_for: 'Billing for',
  taxes_management: 'Taxes management',
  random_discription: 'A random description for a support fee.',
  personal_business: 'Personal & Business',
  exclusive: 'Exclusive',
  support_fee: 'Support Fee',
  call_to_action: 'Call to Action',
  language: 'Language',
  users: 'Users',
  add_plan: 'Add Plan',
  interval_count: 'Interval Count',
  interval: 'Interval',
  trial_days: 'Trial Days',
  year: 'year',
  month: 'month',

  countries: {
    afghanistan: '🇦🇫 Afghanistan',
    aland_islands: '🇦🇽 Aland Islands',
    albania: '🇦🇱 Albania',
    algeria: '🇩🇿 Algeria',
    american_samoa: '🇦🇸 American Samoa',
    andorra: '🇦🇩 Andorra',
    angola: '🇦🇴 Angola',
    anguilla: '🇦🇮 Anguilla',
    antarctica: '🇦🇶 Antarctica',
    antigua_barbuda: '🇦🇬 Antigua and Barbuda',
    argentina: '🇦🇷 Argentina',
    armenia: '🇦🇲 Armenia',
    aruba: '🇦🇼 Aruba',
    australia: '🇦🇺 Australia',
    austria: '🇦🇹 Austria',
    azerbaijan: '🇦🇿 Azerbaijan',
    bahamas: '🇧🇸 Bahamas',
    bahrain: '🇧🇭 Bahrain',
    bangladesh: '🇧🇩 Bangladesh',
    barbados: '🇧🇧 Barbados',
    belarus: '🇧🇾 Belarus',
    belgium: '🇧🇪 Belgium',
    belize: '🇧🇿 Belize',
    benin: '🇧🇯 Benin',
    bermuda: '🇧🇲 Bermuda',
    bhutan: '🇧🇹 Bhutan',
    bolivia: '🇧🇴 Bolivia',
    eustatius_saba: '🇧🇶 Bonaire, Sint Eustatius and Saba',
    bosnia_herzegovina: '🇧🇦 Bosnia and Herzegovina',
    botswana: '🇧🇼 Botswana',
    bouvet_island: '🇧🇻 Bouvet Island',
    brazil: '🇧🇷 Brazil',
    british_indian: '🇮🇴 British Indian Ocean Territory',
    brunei_darussalam: '🇧🇳 Brunei Darussalam',
    bulgaria: '🇧🇬 Bulgaria',
    burkina_faso: '🇧🇫 Burkina Faso',
    burundi: '🇧🇮 Burundi',
    cambodia: '🇰🇭 Cambodia',
    cameroon: '🇨🇲 Cameroon',
    canada: '🇨🇦 Canada',
    cape_verde: '🇨🇻 Cape Verde',
    cayman_islands: '🇰🇾 Cayman Islands',
    central_african: '🇨🇫 Central African Republic',
    chad: '🇹🇩 Chad',
    chile: '🇨🇱 Chile',
    china: '🇨🇳 China',
    christmas_island: '🇨🇽 Christmas Island',
    cocos_islands: '🇨🇨 Cocos (Keeling) Islands',
    colombia: '🇨🇴 Colombia',
    comoros: '🇰🇲 Comoros',
    congo: '🇨🇬 Congo',
    democratic_republic: '🇨🇩 Congo, Democratic Republic of the Congo',
    cook_islands: '🇨🇰 Cook Islands',
    costa_rica: '🇨🇷 Costa Rica',
    cote_ivoire: '🇨🇮 Cote D Ivoire',
    croatia: '🇭🇷 Croatia',
    cuba: '🇨🇺 Cuba',
    curacao: '🇨🇼 Curacao',
    cyprus: '🇨🇾 Cyprus',
    czech_republic: '🇨🇿 Czech Republic',
    denmark: '🇩🇰 Denmark',
    djibouti: '🇩🇯 Djibouti',
    dominica: '🇩🇲 Dominica',
    dominican_republic: '🇩🇴 Dominican Republic',
    ecuador: '🇪🇨 Ecuador',
    egypt: '🇪🇬 Egypt',
    el_salvador: '🇸🇻 El Salvador',
    equatorial_guinea: '🇬🇶 Equatorial Guinea',
    eritrea: '🇪🇷 Eritrea',
    estonia: '🇪🇪 Estonia',
    ethiopia: '🇪🇹 Ethiopia',
    falkland_islands: '🇫🇰 Falkland Islands (Malvinas)',
    faroe_islands: '🇫🇴 Faroe Islands',
    fiji: '🇫🇯 Fiji',
    finland: '🇫🇮 Finland',
    france: '🇫🇷 France',
    french_guiana: '🇬🇫 French Guiana',
    french_polynesia: '🇵🇫 French Polynesia',
    southern_territories: '🇹🇫 French Southern Territories',
    gabon: '🇬🇦 Gabon',
    gambia: '🇬🇲 Gambia',
    georgia: '🇬🇪 Georgia',
    germany: '🇩🇪 Germany',
    ghana: '🇬🇭 Ghana',
    gibraltar: '🇬🇮 Gibraltar',
    greece: '🇬🇷 Greece',
    greenland: '🇬🇱 Greenland',
    grenada: '🇬🇩 Grenada',
    guadeloupe: '🇬🇵 Guadeloupe',
    guam: '🇬🇺 Guam',
    guatemala: '🇬🇹 Guatemala',
    guernsey: '🇬🇬 Guernsey',
    guinea: '🇬🇳 Guinea',
    guinea_bissau: '🇬🇼 Guinea-Bissau',
    guyana: '🇬🇾 Guyana',
    haiti: '🇭🇹 Haiti',
    heard_island: '🇭🇲 Heard Island and Mcdonald Islands',
    holy_see: '🇻🇦 Holy See (Vatican City State)',
    honduras: '🇭🇳 Honduras',
    hong_kong: '🇭🇰 Hong Kong',
    hungary: '🇭🇺 Hungary',
    iceland: '🇮🇸 Iceland',
    india: '🇮🇳 India',
    indonesia: '🇮🇩 Indonesia',
    iran_islamic: '🇮🇷 Iran, Islamic Republic of',
    iraq: '🇮🇶 Iraq',
    ireland: '🇮🇪 Ireland',
    isle_man: '🇮🇲 Isle of Man',
    israel: '🇮🇱 Israel',
    italy: '🇮🇹 Italy',
    jamaica: '🇯🇲 Jamaica',
    japan: '🇯🇵 Japan',
    jersey: '🇯🇪 Jersey',
    jordan: '🇯🇴 Jordan',
    kazakhstan: '🇰🇿 Kazakhstan',
    kenya: '🇰🇪 Kenya',
    kiribati: '🇰🇮 Kiribati',
    korea_democratic: '🇰🇵 Korea, Democratic Peoples Republic of',
    korea_republic: '🇰🇷 Korea, Republic of',
    kosovo: '🇽🇰 Kosovo',
    kuwait: '🇰🇼 Kuwait',
    kyrgyzstan: '🇰🇬 Kyrgyzstan',
    lao_people: '🇱🇦 Lao Peoples Democratic Republic',
    latvia: '🇱🇻 Latvia',
    lebanon: '🇱🇧 Lebanon',
    lesotho: '🇱🇸 Lesotho',
    liberia: '🇱🇷 Liberia',
    libyan_arab: '🇱🇾 Libyan Arab Jamahiriya',
    liechtenstein: '🇱🇮 Liechtenstein',
    lithuania: '🇱🇹 Lithuania',
    luxembourg: '🇱🇺 Luxembourg',
    macao: '🇲🇴 Macao',
    macedonia_former: '🇲🇰 Macedonia, the Former Yugoslav Republic of',
    madagascar: '🇲🇬 Madagascar',
    malawi: '🇲🇼 Malawi',
    malaysia: '🇲🇾 Malaysia',
    maldives: '🇲🇻 Maldives',
    mali: '🇲🇱 Mali',
    malta: '🇲🇹 Malta',
    marshall_islands: '🇲🇭 Marshall Islands',
    martinique: '🇲🇶 Martinique',
    mauritania: '🇲🇷 Mauritania',
    mauritius: '🇲🇺 Mauritius',
    mayotte: '🇾🇹 Mayotte',
    mexico: '🇲🇽 Mexico',
    micronesia_federated: '🇫🇲 Micronesia, Federated States of',
    moldova_republic: '🇲🇩 Moldova, Republic of',
    monaco: '🇲🇨 Monaco',
    mongolia: '🇲🇳 Mongolia',
    montenegro: '🇲🇪 Montenegro',
    montserrat: '🇲🇸 Montserrat',
    morocco: '🇲🇦 Morocco',
    mozambique: '🇲🇿 Mozambique',
    myanmar: '🇲🇲 Myanmar',
    namibia: '🇳🇦 Namibia',
    nauru: '🇳🇷 Nauru',
    nepal: '🇳🇵 Nepal',
    netherlands: '🇳🇱 Netherlands',
    netherlands_antilles: '🇦🇳 Netherlands Antilles',
    new_caledonia: '🇳🇨 New Caledonia',
    new_zealand: '🇳🇿 New Zealand',
    nicaragua: '🇳🇮 Nicaragua',
    niger: '🇳🇪 Niger',
    nigeria: '🇳🇬 Nigeria',
    niue: '🇳🇺 Niue',
    norfolk_island: '🇳🇫 Norfolk Island',
    northern_mariana: '🇲🇵 Northern Mariana Islands',
    norway: '🇳🇴 Norway',
    oman: '🇴🇲 Oman',
    pakistan: '🇵🇰 Pakistan',
    palau: '🇵🇼 Palau',
    palestinian_territory: '🇵🇸 Palestinian Territory, Occupied',
    panama: '🇵🇦 Panama',
    papua_new: '🇵🇬 Papua New Guinea',
    paraguay: '🇵🇾 Paraguay',
    peru: '🇵🇪 Peru',
    philippines: '🇵🇭 Philippines',
    pitcairn: '🇵🇳 Pitcairn',
    poland: '🇵🇱 Poland',
    portugal: '🇵🇹 Portugal',
    puerto_rico: '🇵🇷 Puerto Rico',
    qatar: '🇶🇦 Qatar',
    reunion: '🇷🇪 Reunion',
    romania: '🇷🇴 Romania',
    russian_federation: '🇷🇺 Russian Federation',
    rwanda: '🇷🇼 Rwanda',
    saint_barthelemy: '🇧🇱 Saint Barthelemy',
    saint_helena: '🇸🇭 Saint Helena',
    saint_kitts: '🇰🇳 Saint Kitts and Nevis',
    saint_lucia: '🇱🇨 Saint Lucia',
    saint_martin: '🇲🇫 Saint Martin',
    saint_pierre: '🇵🇲 Saint Pierre and Miquelon',
    saint_vincent: '🇻🇨 Saint Vincent and the Grenadines',
    samoa: '🇼🇸 Samoa',
    san_marino: '🇸🇲 San Marino',
    sao_tome: '🇸🇹 Sao Tome and Principe',
    saudi_arabia: '🇸🇦 Saudi Arabia',
    senegal: '🇸🇳 Senegal',
    serbia: '🇷🇸 Serbia',
    serbia_montenegro: '🇨🇸 Serbia and Montenegro',
    seychelles: '🇸🇨 Seychelles',
    sierra_leone: '🇸🇱 Sierra Leone',
    singapore: '🇸🇬 Singapore',
    sint_maarten: '🇸🇽 Sint Maarten',
    slovakia: '🇸🇰 Slovakia',
    slovenia: '🇸🇮 Slovenia',
    solomon_islands: '🇸🇧 Solomon Islands',
    somalia: '🇸🇴 Somalia',
    south_africa: '🇿🇦 South Africa',
    south_georgia: '🇬🇸 South Georgia and the South Sandwich Islands',
    south_sudan: '🇸🇸 South Sudan',
    spain: '🇪🇸 Spain',
    sri_lanka: '🇱🇰 Sri Lanka',
    sudan: '🇸🇩 Sudan',
    suriname: '🇸🇷 Suriname',
    svalbard_jan: '🇸🇯 Svalbard and Jan Mayen',
    swaziland: '🇸🇿 Swaziland',
    sweden: '🇸🇪 Sweden',
    switzerland: '🇨🇭 Switzerland',
    syrian_arab: '🇸🇾 Syrian Arab Republic',
    taiwan_province: '🇹🇼 Taiwan, Province of China',
    tajikistan: '🇹🇯 Tajikistan',
    tanzania_united: '🇹🇿 Tanzania, United Republic of',
    thailand: '🇹🇭 Thailand',
    timor_leste: '🇹🇱 Timor-Leste',
    togo: '🇹🇬 Togo',
    tokelau: '🇹🇰 Tokelau',
    tonga: '🇹🇴 Tonga',
    trinidad_tobago: '🇹🇹 Trinidad and Tobago',
    tunisia: '🇹🇳 Tunisia',
    turkey: '🇹🇷 Turkey',
    turkmenistan: '🇹🇲 Turkmenistan',
    turks_caicos: '🇹🇨 Turks and Caicos Islands',
    tuvalu: '🇹🇻 Tuvalu',
    uganda: '🇺🇬 Uganda',
    ukraine: '🇺🇦 Ukraine',
    united_arab: '🇦🇪 United Arab Emirates',
    united_kingdom: '🇬🇧 United Kingdom',
    united_states: '🇺🇸 United States',
    unitedStates_minor: '🇺🇲 United States Minor Outlying Islands',
    uruguay: '🇺🇾 Uruguay',
    uzbekistan: '🇺🇿 Uzbekistan',
    vanuatu: '🇻🇺 Vanuatu',
    venezuela: '🇻🇪 Venezuela',
    viet_nam: '🇻🇳 Viet Nam',
    virgin_islands: '🇻🇬 Virgin Islands, British',
    islands_us: '🇻🇮 Virgin Islands, U.s.',
    wallis_futuna: '🇼🇫 Wallis and Futuna',
    western_sahara: '🇪🇭 Western Sahara',
    yemen: '🇾🇪 Yemen',
    zambia: '🇿🇲 Zambia',
    zimbabwe: '🇿🇼 Zimbabwe',
  },

  create_code: 'Create Code',
  create_newCode: 'Create a new Code',

  miscellaneous: {
    tweel_url: 'Add Tweet URL',
    divider: 'Divider',
    divider_cap: 'DIVIDER',
    add_share: 'Add a Share Block',
    add_countdown: 'ADD COUNTDOWN TIMER',
    edit_countdown: 'EDIT COUNTDOWN TIMER',
    enter_countdown_description: 'Enter Countdown Description',
    date_time: 'Date & Time',
    add_action: 'Add an Action',
    add_faq: 'Add FAQs',
    email_me: 'Email me',

    discount_plan: 'Choose a discount between 1% and 99% off for the code',
    bulk_generator: 'Bulk Generator',
  },

  edit_taxes: {
    create_new: 'Create a new tax',
    created_tax:
      'Once a tax is created, it canot be edited or deleted. After the tax is created, you can associate it with your created Plans.',
    percentage: 'Percentage',
    taxes: 'Taxes',
    edittax: 'Edit tax',
    edit: 'Edit',
    ADD: 'ADD',
    edit_cap: 'EDIT',
    description: 'Description',
    tax_value: 'Tax value',
    value_type: 'Value Type',
    fixed: 'Fixed',
    inclusive: 'Inclusive',
    exclusive: 'Exclusive',
    personal_only: 'Personal only',
    business_only: 'Business only',
    personal_business: 'Personal & Business',
    billing_for: 'Billing for',
    countries: 'Countries',

    select:
      'Select the countries that you want to apply this tax on. Leave empty if you want the tax to be applied for all countries.',
  },

  planss: {
    edit_plan: ' Edit Plan',
    plan_features: 'Plan Features',
    set: ' Set',
    for_unlimited: 'for unlimited',
    total_amoutpage:
      'The total amount of biolink pages that a user can create.',
    total_shortlink:
      'The total amount of shortened links that a user can create.',
    total_filelink: 'The total amount of file links that a user can create.',
    vcard_Limit: 'Vcard links Limit',
    totl_vcard: ' The total amount of vcard links that a user can create.',
    total_eventlinks: 'The total amount of event links that a user can create.',
    total_domain: 'The total amount of custom domains that a user can add. ',
    link_state:
      '  How many days will the links statistics be kept in the database.',
    enable_blocks: 'Enabled Biolink Blocks',
    select_blocks:
      'Select which biolink page blocks are enabled for usage on this plan.',
    state_retention: 'Links statistics retention (days)',
    custom_domain: 'Custom Domains Limit',
    event_limit: 'Events links Limit',
    file_limit: 'File links Limit',
    link_limit: 'Links Limit',
    blocks_limit: 'Biolink blocks per biolink page limit',
    biolink_limit: 'Biolinks Limits',
    qr_limit: 'QR Codes Limits',
    pixels_limits: 'Pixels Limits',
    project_limits: 'Project Limits',
    additional_block: 'Additional Global Domains',
    additional_blockDes:
      'Enabling this will make all people having this plan be able to use all the additional global domains.',
    back_half: 'Custom back-half',
    back_halfDes:
      'Enabling this will give the ability for users to have custom URL aliases instead of auto-generated ones.',
    deep_link: 'Deep links',
    deep_linkDes:
      'Enabling this will give the ability to the user to use deep links to point to specific apps instead of only http and https urls.',
    enable_ad:
      'Enabling this will make all people having this plan to not see any ads',
    remove_brand: 'Removable Footer Branding',
    remove_brandDes:
      'This gives the option for people to remove branding from the biolinks footer.',
    button_url: 'Contact Button URL',
    description: 'Description',
    phone_collector: 'Phone collector',
    email_collector: 'Email collector',
    paragraph: 'Paragraph',
    custom_branding: 'Custom Footer Branding',
    custom_brandingDes:
      'This gives the option for people to add their custom branding for the biolinks footer.',
    colored_links: 'Colored Links',
    colored_linksDes:
      'Gives the user the ability to customize the color of their biolinks links',
    advanced_statistics: 'Advanced Statistics',
    check_stat:
      'Gives the user the ability to check more in depth statistics and select the time frame',
    custom_backgrounds: 'Custom Backgrounds',
    custom_backgroundDes:
      'Gives the user the ability to add custom backgrounds on their biolinks pages ( colors, gradients and actual images ).',
    temporary_URL: 'Temporary URL',
    temporary_urlDes:
      'Gives the user the ability to schedule links & limit clicks.',
    seo_des:
      'Gives the user the ability to change the Title and Meta Description of Biolink pages',
    utm_des:
      'Gives the user the ability to set global UTM parameters for all the links inside of a Biolink page.',
    fonts_des:
      'Gives the user the ability to pick a font of his liking from the list of extra fonts.',
    password_protection: 'Password protection',
    password_protectionDes:
      'Gives the user the ability to password protect their links.',
    sensitive_content: 'Sensitive content warning',
    sensitive_contentDes:
      'Gives the user the ability to enable a sensitive content warning on their links.',
    leap_linkDes:
      'Gives the user the ability to temporarily redirect biolink pages to a particular URL.',
    dofollow_link: 'Dofollow biolink links',
    dofollow_linkDes:
      'The user biolink links will have the dofollow property, otherwise it is set to nofollow by default.',
    rest_api: 'Enable ability for the user to use the REST API.',
    customcss_des:
      'Enable ability to add custom css for each biolink page. Be aware to only allow trusted people to use this feature.',
    customjs_des:
      'Enable ability to add custom js for each vcard. Be aware to only allow trusted people to use this feature.',
    product_name: 'Product Name',
    order: 'Order',
    plan_name: 'Plan Name',
    action: 'Action',
  },

  filtermodal: {
    all: 'All',
    unconfirmed: 'Unconfirmed',
    admin_created: 'Admin created',
    admin_api: 'Admin API created',
    facebook_login: 'Facebook login',
    twitter_login: 'Twitter login',
    discord_login: 'Discord login',
    google_login: 'Google login',
    registration_date: 'Registration date',
    ascending: 'Ascending',
    descending: 'Descending',
    ten: '2',
    twentyfive: '3',
    fifty: '5',
    hundred: '7',
    twohundred: '10',
    fivehundred: '20',
    filters: 'Filters',
    order_by: 'Order by',
    results_page: 'Results per page',
    created_datetime: 'Created datetime',
    redeemable: 'Redeemable',
    dayss: 'Days',
    external_payment: 'External Payment ID',
    paid: 'Paid',
    pending: 'Pending',
    offline_payment: 'Offline payment',
    coinbase: 'Coinbase',
    payU: 'PayU',
    paystack: 'Paystack',
    razorpay: 'Razorpay',
    mollie: 'Mollie',
    yookassa: 'Yookassa',
    crypto: 'Crypto.com',
    paddle: 'Paddle',
    monthly_payments: 'Monthly Payments',
    missing_translation:
      'missing_translation: admin_payments.filters.order_by_name',
    missing_translate:
      'missing_translation: admin_payments.filters.order_by_email',
  },

  location: {
    addpin: 'Add Pin',
    cancel_adding_pin: 'Cancel Adding Pin',
    adress: 'Adress',
    adress_placeholder: '123 Main St, City',
    phone: 'Phone',
    phone_placeholder: '123-456-7890',
    add_location: 'Add Location',
    set_primary: 'Set as Primary',
    primary_location: 'Primary Location',
    get_directions: 'Get Directions',
    added_any_location: "You haven't added any Location",
    adress_title_caps: 'ADD ADDRESS TITLE',
    adress_details_caps: 'ADD ADRESS DETAILS',
    enter_location_name: 'Enter Location Name',
    enter_location_adress: 'Enter Location Adress',
    enter_location_phone: 'Enter Location Phone',
    set_default_location: 'Set this location as your main/default',
    home: 'Home',
  },
  report: {
    report_abuse: 'Report Abuse',
    page_url: 'Page URL',
    enter_page_url: 'Enter Page URL that is being reported',
    report_type: 'Type of Report',
    reporter_type: 'Reporter type',
    additional_comment: 'Additional Comment',
    attachment: 'Attachment',
    select_report_type: 'Select a report type',
    spam_scam_phishing: 'Spam, Scam or Phishing',
    adult_content: 'Adult Content',
    illegal_goods_services: 'Illegal goods and services',
    fraud: 'Fraud',
    child_abuse: 'Child Abuse',
    shocking_violent_content: 'Shocking or violent content',
    privacy_impersonation_harassment: 'Privacy, impersonation and harassment',
    gambling: 'Gambling',
    select_reporter_type: 'Select a reporter type',
    bil_bio_user: 'Bil Bio user',
    non_bil_bio_user: 'Non Bil Bio user',
    legal_representative: 'Legal representative',
    law_enforcement: 'Law enforcement',
    regulatory_body: 'Regulatory Body',
    child_abuse: 'Child Abuse',
    shocking_violent_content: 'Shocking or violent content',
    privacy_impersonation_harassment: 'Privacy, impersonation and harassment',
    gambling: 'Gambling',
    type_report_required: 'Type of Report is required',
    type_reporter_required: 'Reporter type is required',
    comment_required: 'Comment is required',
    url_required: 'Page URL is required',
    report_abuse: 'Report Abuse',
    page_url: 'Page URL',
    enter_page_url: 'Enter Page URL that is being reported',
    report_type: 'Type of Report',
    reporter_type: 'Reporter type',
    additional_comment: 'Additional Comment',
    attachment: 'Attachment',
    select_report_type: 'Select a report type',
    spam_scam_phishing: 'Spam, Scam or Phishing',
    adult_content: 'Adult Content',
    illegal_goods_services: 'Illegal goods and services',
    fraud: 'Fraud',
    child_abuse: 'Child Abuse',
    shocking_violent_content: 'Shocking or violent content',
    privacy_impersonation_harassment: 'Privacy, impersonation and harassment',
    select_reporter_type: 'Select a reporter type',
    bil_bio_user: 'Bil Bio user',
    non_bil_bio_user: 'Non Bil Bio user',
    legal_representative: 'Legal representative',
    law_enforcement: 'Law enforcement',
    regulatory_body: 'Regulatory Body',
    gambling: 'Gambling',
    type_report_required: 'Type of Report is required',
    type_reporter_required: 'Reporter type is required',
    comment_required: 'Comment is required',
    url_required: 'Page URL is required',
    report_sentence: 'With this form you can report any abuse of the bil bio',
    site_protected: 'This site is protected by reCAPTCHA and the Google',
    apply: 'apply',
    attachment_paragraph: 'Drag and drop file here or Browse.',
    attachment_required: 'Attachment is Required',
    your_submission_received: "Your submission has been received!",
    you_will_contacted: "You will be contacted if necessary.",
    go_home: "GO HOME",
  },
  language_setting: {
    language_cap: 'Language',
    update_with_unique_identity:
      'Update your page name to create your unique identity',
    added_languge: 'Added Language',
    more_lang_cap: 'ADD MORE LANGUAGE',
    english: 'English',
    arabic: 'Arabic',
    sidebar_language: 'Language',
    french: 'French',
    chinese: 'Chinese',
    vietnamese: 'Vietnamese',
    search_other_lang: 'Search Other Languages',
    english_default: 'English (default)',
  },

  want_to_delete: 'Are you sure you want to delete this?',
  get_started_now: 'GET STARTED NOW',
  join_waiting_list: 'Join a Waiting List',
  package_suitable_people: 'This Package Is Suitable For Teams 1-15 People.',
  we_use_cookies: ' We use cookies',
  we_use_cookies_and_other_technologies:
    'We use cookies and other tracking technologies to improve your browsing experience on our website, to show you personalized content and targeted ads, to analyze our website traffic, and to understand where our visitors are coming from.',
  customize: 'Customize',
  reject_all: 'Reject All',
  accept_all: 'Accept All',
  cookies_preference_center: 'Cookies Preferences Center',
  select_lang: 'Select A Language',
  your_privacy: 'Your Privacy',

  strict_necessary_cookies: 'Strictly necessary cookies',
  functionality_cookies: 'Functionality cookies',
  tracking_cookies: 'Tracking cookies',
  targeting_cookies: 'Targeting and advertising cookies',
  more_info: 'More information',

  privacy_is_import: 'Your privacy is important to us',
  cookies_detailed_message:
    'Cookies are very small text files that are stored  on your computer when you visit a website. We use  cookies for a variety of purposes and to enhance  your online experience on our website (for  example, to remember your account login details).  You can change your preferences and decline  certain types of cookies to be stored on your  computer while browsing our website. You can also  remove any cookies already stored on your  computer, but keep in mind that deleting cookies  may prevent you from using parts of our website.',
  always_active: 'Always Active',
  in_active: 'In Active',
  active: "Active",
  cookies_consent: 'Cookie Consent by',
  terms_feed: 'TermsFeed',
  save_my_preferences: 'Save my preferences',
  privacy_title: "Your privacy is important to us",
  privacy_content: "Cookies are very small text files that are stored on your computer when you visit a website. We use cookies for a variety of purposes and to enhance your online experience on our website (for example, to remember your account login details). You can change your preferences and decline certain types of cookies to be stored on your computer while browsing our website. You can also remove any cookies already stored on your computer, but keep in mind that deleting cookies may prevent you from using parts of our website.",
  strictly_necessary_title: "Strictly necessary cookies",
  strictly_necessary_content: "These cookies are essential to provide you with services available through our website and to enable you to use certain features of our website. Without these cookies, we cannot provide you certain services on our website.",
  functionality_title: "Functionality cookies",
  functionality_content: "These cookies are used to provide you with a more personalized experience on our website and to remember choices you make when you use our website. For example, we may use functionality cookies to remember your language preferences or remember your login details.",
  tracking_title: "Tracking cookies",
  tracking_content: "These cookies are used to collect information to analyze the traffic to our website and how visitors are using our website. For example, these cookies may track things such as how long you spend on the website or the pages you visit which helps us to understand how we can improve our website for you. The information collected through these tracking and performance cookies do not identify any individual visitor.",
  targeting_advertising_title: "Targeting and advertising cookies",
  targeting_advertising_content: "These cookies are used to show advertising that is likely to be of interest to you based on your browsing habits. These cookies, as served by our content and/or advertising providers, may combine information they collected from our website with other information they have independently collected relating to your web browser's activities across their network of websites. If you choose to remove or disable these targeting or advertising cookies, you will still see adverts but they may not be relevant to you.",
  more_info_title: "More information",
  more_info_content: "For any queries in relation to our policy on cookies and your choices, please contact us.",
  read_more: "Read More",
  read_less: "Read Less",

  user_analytics: {
    analytics: 'Analytics',
    some_states: 'Let’s check some stats today!',
    feature_available: 'This feature is only available for',
    pro_user: 'Pro Users',
    upgrade: 'UPGRADE TO PRO',
    weak:'Weak',
    month:'Month',
    year:'Year',
    custom_duration:'Custom Duration',
    no_visitor:'Number of Visitors',
    no_clicks:'Number of Clicks',
    insta:'Instagram',
    twitter:'Twitter',
    youtube:'YouTube',
    linkedin:'LinkedIn',
    pinterest:'Pinterest',
    facebook:'Facebook',
    visitor_by_day:'Visitor by day and time',
    sat: 'Sat',
    sun: 'Sun',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri'
  },

  createPassword: {
    title: "Enter Password",
    description: "Enter password to complete your account.",
    password: "Password",
    enterPassword: "Enter Password",
    confirmPassword: "Confirm Password",
    enterConfirmPassword: "Enter Confirm Password",
    accountAgreement: "By creating an account, you agree to our Privacy Policy and Terms & Conditions.",
    createAccount: "CREATE ACCOUNT",
    alreadyHaveAccount: "Already have an account?",
    logIn: "LOG IN",
  },
  
  my_location: "My Location",
  be_the_first_to: "Be the first to",
  bil_bio: "Bil.Bio",
  experience: "experience",
  waitlist_early_access: "Sign Up Now to Join the Waitlist for Early Access. Be part of our journey!",
  you_are_waitlist: "You're on the waitlist!",
  thanks_joining_waitlist: "Thanks for joining our waitlist! You'll be among the first to know as we get closer to launching our new platform.Stay tuned for updates and exclusive insights. We're excited to have you with us!",
  main_title_part_one: "Build one single link",
  main_title_part_two: "for all your links",
  no_blocks_found: "No Blocks Found!",
  lorem_ipsum_dolor: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Elit urna dictum placerat urna iaculis",
}

export default en
